import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button, Typography, message } from "antd";
import { connect } from "react-redux";
import ReactCodeInput from "react-verification-code-input";

import { ROW_JUSTIFY, COL_SPAN, LOCAL_LANG } from "../common/const";
import { PostMfaCheck, PostTeamJoin } from "../config/request";
import {
  OpenBrowserUrl,
  getDeviceType,
  CheckSystem,
  getNextPathByRegisterStatus,
  getRedirectUrl,
} from "../common/globalFun";
import { useIntl } from "react-intl";

import HeaderLogo from "../components/HeaderLogo";
import PageBg from "../components/PageBg";
import ErrorInfoTip from "../components/ErrorInfoTip";
import PageHeaderComponents from "../components/PageHeader";

import "./css/style.css";

const { Title } = Typography;

const VerifyMFAPage = (props) => {
  const { history } = props;
  const intl = useIntl();

  const [loading, setLoading] = useState(false);
  const reactCodeInputRef = useRef();
  const [errMessage, setErrMessage] = useState("");

  const submit = (values) => {
    const { code } = values;
    checkCode(code);
  };

  const VerifyCodeOnComplete = (value) => {
    checkCode(value);
  };

  const autoJoinOrg = (account, invite_code) => {
    setLoading(true);
    PostTeamJoin({
      account: account,
      invite_code: invite_code,
    })
      .then((rsp) => {
        if (CheckSystem.Felo()) {
          const { loginKey, login_key } = rsp;
          props.setGlobalLoginKey(loginKey || login_key);
          history.push("/download");
        } else {
          OpenBrowserUrl(getRedirectUrl());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkCode = (code) => {
    setLoading(true);
    PostMfaCheck({
      mfa_type: "email",
      recheck_key: props.emailCheckKey,
      check_code: code,
      device_type: getDeviceType(),
    })
      .then((rsp) => {
        const { status, inviteStatus, loginKey } = rsp;
        const nextPath = getNextPathByRegisterStatus(status);

        if (inviteStatus) {
          history.replace({ pathname: "/invite_list" });
        } else {
          if (props.inviteCode) {
            // 邀请页面过来的自动加入该组织
            autoJoinOrg(props.email, props.inviteCode);
            return;
          }
          if (loginKey && CheckSystem.Felo()) {
            props.setGlobalLoginKey(loginKey);
            history.push("/download");
            return;
          }
          history.replace(nextPath);
        }
      })
      .catch(() => {
        reactCodeInputRef.current.__clearvalues__();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clearErrMessage = () => {
    setErrMessage("");
  };

  return (
    <>
      <PageHeaderComponents
        className="page-header"
        title=" "
        onBack={() => {
          history.push("/login");
        }}
      />
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full verify-page`}
      >
        <Col span={COL_SPAN}>
          <section className={`hd-section createTeamHead`}>
            <HeaderLogo />
            <Title level={2} className="mt-10">
              {intl.formatMessage({ id: "title.mfa" })}
            </Title>
            <p className="title-exp">
              {intl.formatMessage({ id: "send.email.to" })}
              <strong>{props.email}</strong>
              <br />
              {intl.formatMessage({ id: "enter.verify.code" })}
            </p>
          </section>
          <section className="content-center">
            <Form onFinish={submit}>
              <Form.Item name="code">
                <ReactCodeInput
                  ref={reactCodeInputRef}
                  autoFocus
                  className={`margin-center mt-30 verify-code-wrap`}
                  fieldWidth={80}
                  fieldHeight={80}
                  loading={loading}
                  onComplete={VerifyCodeOnComplete}
                  onChange={clearErrMessage}
                />
              </Form.Item>
            </Form>

            <ErrorInfoTip text={errMessage} />

            <p className="mt-50">
              {intl.formatMessage({ id: "find.code.tip" })}
              <br />
              {intl.formatMessage({ id: "find.code.tip2" })}
              <Button
                type="link"
                size="small"
                onClick={() => {
                  OpenBrowserUrl("https://twitter.com/FeloApp", "_self", false);
                }}
              >
                {intl.formatMessage({ id: "contact.us.lower" })}
              </Button>
            </p>
          </section>
        </Col>
      </Row>
    </>
  );
};

const stateProps = (state) => {
  return {
    token: state.token,
    email: state.email,
    redirectUri: decodeURIComponent(state.redirectUri),
    inviteCode: state.inviteCode,
    emailCheckKey: state.emailCheckKey,
  };
};

const dispatchProps = (dispatch) => ({
  setGlobalLoginKey: (key) => {
    dispatch({
      type: "setLoginKey",
      value: key,
    });
  },
});

export default connect(stateProps, dispatchProps)(VerifyMFAPage);
